import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import apis from "@/api";
import type { Website } from "@/api/Website";
import type { Cate, Tree } from "@/api/catelog";
import { transferArrayToTree } from "@/api/catelog";


export default /*#__PURE__*/_defineComponent({
  emits: ["closeModal"],
  setup(__props, { expose, emit: emits }) {

expose({ openModal });


const websiteModalVisible = ref(false);
const currentWebsite = ref<Website>({ type: 1 });
const catalogTree = ref<Array<Tree>>([]);
const type = ref("add");

/**
 * 打开弹窗，初始化
 */
function openModal(mode: string, catalogId: number, website?: Website) {
  type.value = mode;
  getCatalogTree();
  console.log(mode);
  if (mode == "add") {
    currentWebsite.value.catalogId = catalogId;
    currentWebsite.value.url = "";
    currentWebsite.value.title = "";
    currentWebsite.value.description = "";
  } else if (website) {
    currentWebsite.value = website;
  }
  websiteModalVisible.value = true;
}

function cancel() {
  currentWebsite.value = { type: 1 };
  websiteModalVisible.value = false;
}

/**
 * 新增或修改网址
 */
function saveOrUpdate() {
  currentWebsite.value.createTime = undefined;
  currentWebsite.value.updateTime = undefined;
  if (type.value == "add") {
    currentWebsite.value.id = undefined;
  }
  apis.website.saveOrUpdateWebsite.request<Website>(currentWebsite.value).then((res) => {
    websiteModalVisible.value = false;
    emits("closeModal");
  });
}

/**
 * 获取目录树
 */
function getCatalogTree() {
  apis.catelog.selectCateList.request<Array<Cate>>({ type: 3 }).then((res) => {
    if (res.data) {
      catalogTree.value = transferArrayToTree(res.data);
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: websiteModalVisible.value,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((websiteModalVisible).value = $event)),
    title: type.value == 'add' ? '添加网页' : '编辑网页',
    onOk: saveOrUpdate,
    onCancel: cancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_tree_select, {
        value: currentWebsite.value.catalogId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((currentWebsite.value.catalogId) = $event)),
        "show-search": "",
        style: {"width":"100%"},
        "dropdown-style": { maxHeight: '400px', overflow: 'auto' },
        placeholder: "Please select",
        "allow-clear": "",
        "tree-default-expand-all": "",
        "tree-data": catalogTree.value
      }, {
        title: _withCtx(({ value: val, title }) => [
          _createTextVNode(_toDisplayString(title), 1)
        ]),
        _: 1
      }, 8, ["value", "tree-data"]),
      _createVNode(_component_a_input, {
        value: currentWebsite.value.url,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((currentWebsite.value.url) = $event)),
        placeholder: "URL地址"
      }, null, 8, ["value"]),
      _createVNode(_component_a_input, {
        value: currentWebsite.value.title,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((currentWebsite.value.title) = $event)),
        placeholder: "标题"
      }, null, 8, ["value"]),
      _createVNode(_component_a_input, {
        value: currentWebsite.value.description,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((currentWebsite.value.description) = $event)),
        placeholder: "描述"
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})